import React, { useState } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import { Box, Button, Link } from "@mui/material";
import RKTextField from "../../../../../../../Supporting files/RKTextField/RKTextField";
import SlidingPanel from "react-sliding-side-panel";

interface Props {
  open_status: boolean;
  attrName: any;
  value_update: Function;
}

const ChangePassword: React.FC<Props> = ({
  open_status,
  attrName,
  value_update,
}) => {
  const [oldPassword, setOldPassword] = React.useState("");
  const [newPassword, setNewPassword] = React.useState("");
  const [confirmPassword, setConfirmPassword] = React.useState("");
  const [pageStatus, setPageStatus] = React.useState<number>(1);

  const updateMasterState = (
    attrName: any,
    value: string | boolean | number
  ) => {
    attrName(value);
  };

  return (
    <SlidingPanel
      type={"right"}
      isOpen={open_status}
      size={75}
      panelClassName="slidingPanel"
      backdropClicked={() => value_update(attrName, false)}>
      <Box className="pt-3 pl-3 pr-3">
        <div>
          <Grid container spacing={3} alignItems="center">
            <Grid xs={12}>
              <h4 className="mb-0 text-center">Change Password</h4>
            </Grid>
            <Grid xs={12} className="mb-5">
              <hr />
            </Grid>
          </Grid>
          <div className="scrollable_area">
            {pageStatus !== 2 ? (
              <Grid
                container
                spacing={2}
                justifyContent="center"
                className="mb-3">
                <Grid xs={12}>
                  <RKTextField
                    class_name="inputField"
                    title={"Old Password"}
                    value={oldPassword}
                    attrName={setOldPassword}
                    value_update={updateMasterState}
                    warn_status={false}
                  />
                </Grid>
                <Grid xs={12}>
                  <RKTextField
                    class_name="inputField"
                    title={"New Password"}
                    value={newPassword}
                    attrName={setNewPassword}
                    value_update={updateMasterState}
                    warn_status={false}
                  />
                </Grid>
                <Grid xs={12}>
                  <RKTextField
                    class_name="inputField"
                    title={"Confirm Password"}
                    value={confirmPassword}
                    attrName={setConfirmPassword}
                    value_update={updateMasterState}
                    warn_status={false}
                  />
                </Grid>
              </Grid>
            ) : null}
            {pageStatus === 2 ? (
              <Grid
                container
                spacing={2}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                }}>
                <Grid xs={12}>
                  <svg
                    className="checkmark"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 52 52">
                    <circle
                      className="checkmark__circle"
                      cx="26"
                      cy="26"
                      r="25"
                      fill="none"
                    />
                    <path
                      className="checkmark__check"
                      fill="none"
                      d="M14.1 27.2l7.1 7.2 16.7-16.8"
                    />
                  </svg>
                  <p className="quote_success text-center">
                    Your Password has been added updated successfully!
                  </p>
                </Grid>
              </Grid>
            ) : null}
            {pageStatus !== 2 ? (
              <Grid container spacing={3}>
                <Grid xs={12} className="ctaBtn text-center">
                  <Button
                    variant="contained"
                    className="submitBtn"
                    onClick={() => {
                      setPageStatus(pageStatus + 1);
                    }}>
                    Submit
                  </Button>
                </Grid>
              </Grid>
            ) : null}
          </div>
        </div>
      </Box>
    </SlidingPanel>
  );
};

export default ChangePassword;
